import { render, staticRenderFns } from "./GDSoftBreadcrumb.vue?vue&type=template&id=4e3144a2&"
import script from "./GDSoftBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./GDSoftBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports